<template>
  <div v-if="!workerlist[0]">
    <h4>You must add User and Form before doing work management!</h4>
  </div>
  <div v-else>
    <vs-row class="mb-3" >
      <vs-button color="dark" disabled type="flat"><h5>Manage Work  /  Work Management</h5></vs-button>
    </vs-row>
     <!-- <b-breadcrumb style="background-color: #ffffff; ">
    <b-breadcrumb-item active><h5>Manage Work</h5></b-breadcrumb-item>
    <b-breadcrumb-item active><h5>Work Management</h5></b-breadcrumb-item>
  </b-breadcrumb> -->
<vs-row 
  vs-type="flex" vs-justify="space-between"  vs-w="12">
   <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12" >
    <vs-card style=" background: linear-gradient(45deg,#DEF1FF,#DEF1FF); border-radius: 15px;">
       <vs-row><h4 class="text-info" style="font-weight: 400;" >Open Tasks</h4><vs-spacer /><vs-spacer /><vs-spacer /><vs-icon icon="sync_alt" size="30px" color="#189AFA"></vs-icon></vs-row>
          <br>
          <h4 class="text-center text-info font-weight-bold">{{lt}}</h4>
          
          
    </vs-card>
  </vs-col>
  <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12" >
    <vs-card style=" background: linear-gradient(45deg,#dbf7d7,#dbf7d7); border-radius: 15px;">
      <vs-row><h4 class="text-success " style="font-weight: 400;" >Completed Tasks</h4><vs-spacer /><vs-spacer /><vs-icon icon="done" size="30px" color="#5fa74b"></vs-icon></vs-row>
        <br>
        <h4 class="text-center text-success font-weight-bold">{{ct}}</h4>

        </vs-card>
  </vs-col>
    <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12" >
        <vs-card  style=" background: linear-gradient(45deg,#ffeedb,#ffeedb); border-radius: 15px;">

     <vs-row> <h4 class="text-warning" style="font-weight: 400;  ">On Going</h4><vs-spacer /><vs-icon icon="snooze" size="30px" color="warning"></vs-icon></vs-row>
     <br>
     <h4 class="text-center text-warning font-weight-bold">{{og}}</h4>
    </vs-card>
  </vs-col>
  <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12" >
    <vs-card style="background: linear-gradient(45deg,#ffdfdb,#ffdfdb); border-radius: 15px;">
     <vs-row><h4 class="text-danger " style="font-weight: 400;" >Time Spent</h4><vs-spacer /><vs-icon icon="query_builder" size="30px" color="danger"></vs-icon></vs-row>  
   <br>
    <h4 class="text-center text-danger font-weight-bold">{{ts}} hr</h4>
      
    </vs-card>
  </vs-col>
  </vs-row>
    <vs-row>
      <vs-col >
         <vs-row  id="center">
            <h3 class="ml-1 mt-1 mb-1"  style="color: #111111">
              Assignment of Open Work Orders
            </h3>
            <vs-spacer />
            <vs-tooltip  text="Add New Work Order" position="top" >
              <h6> <vs-button class="mt-1 mb-1" color="success" v-if="role='admin'" style="border-radius: 20px;" size="sm" icon="add" v-b-modal.modal-1 type="filled">New Work Order</vs-button></h6>
            </vs-tooltip>
          <!-- <vs-button v-if="role='admin'" color="#007bff" type="line" icon="add" v-b-modal.modal-1 >New Work Order </vs-button> -->
          <!-- <vs-button v-else color="#007bff" type="line" icon="add" v-b-modal.modal-1 >New Work Order </vs-button> -->
          <!-- <vs-button color="#007bff" type="line" icon="add"  @click="activePrompt = true">New Work Order </vs-button> -->
        </vs-row>
       <br>
        <vs-card style=" border-radius: 20px;">
           <vs-tabs alignment="right" color="#555555">
              <vs-tab  icon="list" label="List View" >
                <Workview :tempdata="tempdata" :selectedWO="selectedWO" :workerlist="workerlist" :workerwork="workerwork" :users="users" :header="header"/>
              </vs-tab>
              <vs-tab icon="event_note" label="Calendar View">
                <CalendarView :users2="users2" :attributes="attributes" :tempdata="tempdata" :selectedWO="selectedWO" :workerlist="workerlist" :workerwork="workerwork" :users="users" :header="header"/>
              </vs-tab>
              <vs-tab v-if="role=='admin'" icon="people"  label="User View">
              
                <!-- <UserView :workerlist="workerlist"  :users2="users2" :attributes="attributes" :tempdata="tempdata" :selectedWO="selectedWO" :workerwork="workerwork" :users="users" :header="header"/> -->
                 <UserView :tempdata="tempdata" :selectedWO="selectedWO" :workerlist="workerlist" :workerwork="workerwork" :users="users" :header="header"/>
              </vs-tab>
            </vs-tabs>
        </vs-card>
     
      </vs-col> 
    </vs-row>


 <b-modal id="modal-1" size="lg" no-close-on-backdrop="false" hide-header-close scrollable centered title="New Work Order " header-close-label >
    <b-alert style="border-radius: 0;" show variant="danger">Fields can not be empty please enter the data</b-alert>
    <p class="my-2 ml-3 mb-2">
       
       <!-- <vs-dropdown v-if="workerlist[0]"> -->
         
       <vs-dropdown>
      <a class="a-icon" href.prevent>
        Select Worker
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="(item,index) in workerlist" :key="index" @click="actionchange(item,1)">
        {{item.name}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    </p>
    <vs-row vs-w="12">
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
    
     <vs-textarea label="Worker's Name" height="60px"  v-model="newwork.name" readonly />
   
  </vs-col>
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    
      <vs-textarea label="Worker's Email" height="60px"  v-model="newwork.email" readonly />
  </vs-col>
 
</vs-row>



    <vs-row vs-w="12">
      <p class="my-2 ml-3 mb-1">
       <vs-dropdown>
      <a class="a-icon" href.prevent>
        Select Form 
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="(item,index) in formlist" :key="index" @click="actionchange(item,2)">
        {{item.conf.formConfig.headline}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    </p>
  <vs-col vs-type="flex"  vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
    <vs-textarea label="Form" height="60px"  v-model="newwork.form.formConfig.headline" readonly />
    
  </vs-col>
</vs-row>

<vs-row vs-w="12">
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12" >
    
    
    Start Date  :   <div style="padding: 20px; padding-left: 14px;  "> <datetime  v-model="newwork.plandate" type="datetime" /></div>
   
  </vs-col>
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="12" vs-xs="12">
    
    Due Date  :   <div style="padding: 20px; padding-left: 20px;  "> <datetime  v-model="newwork.duedate" type="datetime" /></div>
      
  </vs-col>
 
</vs-row>

 <vs-row vs-w="12">
   <p  class="my-2 ml-3 mb-1">Work Detail :</p>
  <vs-col vs-type="flex"  vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
     <vs-textarea   rows="3" v-model="newwork.detail"  />
  </vs-col>
</vs-row>
<vs-alert color="primary" icon="new_releases" >
        
      </vs-alert>
     
     <template #modal-footer="{cancel }">
     <vs-button type="filled" size="sm" style="border-radius: 20px;" v-b-modal.modal-multi-3 @click="newworksent()" color="success"  >Add Work Order</vs-button>
 
 <b-button class="ml-2 mr-4" id="btncancel"  variant="light" @click="cancel()">
        Cancel
      </b-button>
    
   
    </template>
  </b-modal>
 <b-modal id="modal-multi-3" size="lg" title="New Work Order" :ok="refresh">
     <vs-row vs-w="12">
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
    
     <vs-textarea label="Worker's Name" height="60px"  v-model="newwork.name" readonly />
   
  </vs-col>
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    
      <vs-textarea label="Worker's Email" height="60px"  v-model="newwork.email" readonly />
  </vs-col>
 
</vs-row>
<vs-row vs-w="12">
  <vs-col vs-type="flex"  vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
    <vs-textarea label="Form" height="60px"  v-model="newwork.form.formConfig.headline" readonly />
    
  </vs-col>
</vs-row>
 <vs-row vs-w="12">
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12" >
    
     <vs-textarea label="Start Date  :" height="60px"  v-model="newwork.plandate" readonly />
   
  </vs-col>
  <vs-col vs-type="flex"  vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
    
      <vs-textarea label="Due Date  :" height="60px"  v-model="newwork.duedate" readonly />
  </vs-col>
 
</vs-row>
<vs-row vs-w="12">
  <vs-col vs-type="flex"  vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
     <vs-textarea label="Work Detail"  rows="3" v-model="newwork.detail" readonly />
  </vs-col>
</vs-row>



    
     <template #modal-footer="{cancel }">
       <vs-button type="filled" size="sm" style="border-radius: 20px;"  @click="refresh()" color="success"  >Save Work Order</vs-button>
 
 <b-button class="ml-2 mr-4" id="btncancel"  variant="light" @click="cancel()">
        Cancel
      </b-button>
     
    </template>
  </b-modal>
  <!-- <vs-prompt
  color="primary"
  @accept="newworksent"
  title="New Work Order"
  :active.sync="activePrompt">
    <div class="con-exemple-prompt">
     
    <vs-dropdown>
      <a class="a-icon" href.prevent>
        Select Worker
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="(item,index) in workerlist" :key="index" @click="actionchange(item,1)">
        {{item.name}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input style="width: auto" color="#333f50" placeholder="Select Worker" readonly v-model="newwork.name"/><br>
      <vs-input style="width: auto" color="#333f50" placeholder="Worker's Email" readonly v-model="newwork.email"/><br>
      <vs-input style="width: auto" color="#333f50" placeholder="Work Detail" v-model="newwork.detail"/><br>
    <vs-dropdown>
      <a class="a-icon" href.prevent>
        Select Form
        <vs-icon class icon="expand_more"></vs-icon>
      </a>
      <vs-dropdown-menu>
      <vs-dropdown-item v-for="(item,index) in formlist" :key="index" @click="actionchange(item,2)">
        {{item.conf.formConfig.headline}}</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
      <vs-input style="width: auto" color="#333f50" placeholder="Select Form" v-model="newwork.form.formConfig.headline"/><br>
      <vs-row>
        <vs-col vs-lg="6">
          Select Start Date<datetime v-model="newwork.plandate" type="datetime" />
        </vs-col>
        <vs-col vs-lg="6">
          Select Due Date<datetime v-model="newwork.duedate" type="datetime" />
        </vs-col>
      </vs-row>
      <br>
      <vs-alert color="primary" icon="new_releases" >
        Fields can not be empty please enter the data
      </vs-alert>
    </div>
  </vs-prompt> -->
 
  <!-- <vs-prompt
  color="primary"
  @accept="savedetail()"
  title="Work Detail"
  :active.sync="activePrompt2">
  <vs-progress :percent="viewpercentage" color="success">success</vs-progress><br>
    Work Progress {{viewpercentage}}% Completed!<br><br>
  <vs-row>
    <vs-col vs-lg="6">
      <p v-if="viewwork" style="font-size: 120%">
      Started by: {{viewwork.username}}<br>
      Asset: -<br>
      Work detail: {{viewwork.detail}}<br>
      Created date: {{viewwork.timestamp}}<br>
      Last edited: {{viewwork.editdate}}<br>
      Time Spent: {{viewwork.timespent}}
      </p>
    </vs-col>
    <vs-col vs-lg="6">
      <p v-if="viewwork" style="font-size: 120%">
      Plan Date: {{viewwork.plandate}}<br>
      Actual start date: {{viewwork.startdate}}<br>
      Finish date: {{viewwork.finishtime}}<br>
      Status: {{viewwork.iscomplete}}<br>
      WO Status : 
      </p>
    </vs-col>
      <vs-divider></vs-divider>
  </vs-row>
  <FormRenderer
    :form-configuration="formData"
    v-model="formInputData"/>
  </vs-prompt> -->
 <WO v-if="showWork" :viewwork="viewwork"/>
  </div>
</template>

<script>
import UserView from '../dashboard/Workorder/UserView.vue'
import WO from '../material/WorkView.vue'
import Workview from '../dashboard/Workorder/Workview.vue'
import CalendarView from '../dashboard/Workorder/CalendarView.vue'
export default {
  name: 'WorkOrder',
  components: {
    WO,
    Workview,
    CalendarView,
    UserView,
    UserView
  },
  data: () => ({
    viewpercentage: 0,
    header: ['Work ID ','Name','Asset','Work Order','Creator','Start Date','Actual Start Date','End Date','Actual End Date','Time Spent','%','Status'],
    value1: '',
    value2: '',
     descriptionItems: [10,20],
     selected1:[],
     selected2:0,
    formData: null,
    formInputData: null,
    showWork: false,
    attributes: [
      {
        key: 'today',
        highlight: true,
        dates: new Date()
      },
      // {
      //   dot: {
      //     color: 'red',
      //   },
      //   dates: [
      //     new Date(2020, 9, 5)
      //   ]
      // }
    ],
    selected: [],
    ot: 0,
    selectFilter:[],
     options1:[
        {text: 'Name', value: 'Name'},
      ],
     options2:[{text: 'Work Order', value: 'Work Order'},
            {text: 'Asset', value: 'Asset'},
            {text: 'Status', value: 'Status'},
        
      ],
      options3:[
            {text: 'Clear Filter', value: 'clear'},
        
      ],
    lt: 0,
    odt: 0,
    ct: 0,
    ts: 0,
    og: 0,
    activePrompt: false,
    activePrompt2: false,
    checker: 'List',
    newwork:{
      name: '',
      detail:'',
      iscomplete: false,
      form:{'formConfig':{'headline':null}},
      email:'',
      timestamp: '',
      plandate: '',
      duedate: '',
      finishtime: '',
      username: ''
    },
    selectedday: null,
    formlist: [],
    show: false,
    workerlist: [],
    tempdata: [],
    tablename: 'List Table',
    users: [],
    users2: [],
    workerwork: [],
    temp: null,
    viewwork: null,
    role: ''
  }),
  methods: {
    showModalComplete(){
      this.$refs['my-modalcom'].show()
    },
    savedetail() {
      this.$http.post(this.$url+'updatework', {
        inputdata: this.formInputData,
        editdate: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        id: this.viewwork.id
      }).then(() => {
        location.reload()
      })
      this.activePrompt = false
    },
    refresh(){
      location.reload()
    },
    showMsgBoxOne(item) {
        this.boxOne = ''
        this.$bvModal.msgBoxOk('Action completed', {
          title: 'Work Detail',
          size: 'xl',
          buttonSize: 'sm',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
          .then(value => {
            this.boxOne = value
          })
          .catch(err => {
            // An error occurred
          })
      },
    showWorkOrder(item) {
      // console.log(item)
      this.viewwork = item
      this.showWork = true
    },
    filterchange(mode) {
      this.checker = mode
      switch(mode) {
        case 'User':
          this.tablename = 'User Table'
          break;
        case 'Calendar':
          this.users = []
          this.tablename = 'Work on this day'
          this.clicked(this.$moment().format('YYYY-MM-DD'),2)
          break;
        case 'List':
          this.users = this.tempdata
          this.tablename = 'List Table'
          break;
      }
    },
    clicked(item,mode) {
      // console.log(item)
      this.users2 = []
      switch(mode) {
        case 1:
          this.tablename = 'Work on ' +item.ariaLabel
          this.tempdata.forEach(element => {
            if(this.$moment(element.plandate).format('YYYY-MM-DD') == item.id) {
              this.users2.push(element)
            }
          })
          break;
        case 2:
          this.tempdata.forEach(element => {
            if(this.$moment(element.plandate).format('YYYY-MM-DD') == item) {
              this.users2.push(element)
            }
          })
      }
    },
    actionchange(item,mode) {
      this.newwork.timestamp = this.$moment().format('YYYY-MM-DD HH:mm:ss')
      switch(mode) {
        case 1:
          this.newwork.name = item.name
          this.newwork.email = item.email
          break;
        case 2:
          this.newwork.form = item.conf
          break;
      }
    },
    newworksent() {
      this.newwork.duedate = this.$moment(this.newwork.duedate).format('YYYY-MM-DD HH:mm:ss')
      this.$http.post(this.$url+'savework', {
        headers: {
          'Access-Control-Request-Method': '*',
          'Access-Control-Request-Headers': '*',
          'Origin': '*'
        },
        name: this.newwork.name,
        detail: this.newwork.detail,
        iscomplete: false,
        form: this.newwork.form,
        email: this.newwork.email,
        timestamp: this.newwork.timestamp,
        duedate: this.newwork.duedate,
        plandate: this.newwork.plandate,
        finishtime: this.newwork.finishtime,
        username: this.$session.get('username')
      })
      // console.log(this.newwork)
    },
    copysent(item) {
      // console.log(item)
      Object.keys(item).forEach((element) => {
        if(item[element] == '-') item[element] = null
      })
      var name = item.name+' - Copy'
      this.$http.post(this.$url+'savework', {
        headers: {
          'Access-Control-Request-Method': '*',
          'Access-Control-Request-Headers': '*',
          'Origin': '*'
        },
        name: name,
        detail: item.detail,
        iscomplete: false,
        form: item.form,
        email: item.email,
        timestamp: item.timestamp,
        duedate: item.duedate,
        plandate: item.plandate,
        finishtime: item.finishtime,
        username: this.$session.get('username')
      }).then(() => {
        location.reload()
      })
    },
    handleSelected(tempdata) {
      // console.log("hellllll")
    },
    formating(item) {
      item.timespent = this.$moment(item.finishtime).diff(item.startdate, 'hours') || 0
      this.ts += item.timespent
      item.timestamp = this.$moment(item.timestamp).format("YYYY-MM-DD HH:mm:ss")
      item.startdate = this.$moment(item.startdate).format("YYYY-MM-DD HH:mm:ss")
      item.plandate = this.$moment(item.plandate).format("YYYY-MM-DD HH:mm:ss")
      item.duedate = this.$moment(item.duedate).format("YYYY-MM-DD HH:mm:ss")
      item.editdate = this.$moment(item.editdate).format("YYYY-MM-DD HH:mm:ss")
      Object.keys(item).forEach(element => {
        if((element.match('date') || element.match('time')) && !element.match('plandate') && !element.match('spent')) {
          item[element] = this.$moment(item[element]).subtract(7, 'hours').format("YYYY-MM-DD HH:mm:ss")
        }
      });
      if(item.iscomplete == true){
        item.iscomplete = 'Complete'
        this.ct += 1
      }
      else{
        if(item.startdate == 'Invalid date') item.startdate = '-'
        if(item.plandate == 'Invalid date') item.plandate = '-'
        item.finishtime = this.$moment(item.finishtime).format("YYYY-MM-DD HH:mm:ss")
        if(item.finishtime == 'Invalid date') item.finishtime = '-'
        if(item.editdate == 'Invalid date') item.editdate = '-'
        if(!item.timespent) {
          item.iscomplete = 'Upcoming'
          this.ot += 1
        }
        else {
          item.iscomplete = 'Complete'
          this.ct += 1
        }
        if(item.startdate != '-' && item.finishtime == '-') {
          item.iscomplete = 'Open'
          this.og += 1
          this.ot -= 1
        }
        if(item.startdate == '-' && this.$moment(this.$moment().format('YYYY-MM-DD')).isAfter(item.plandate)) {
          this.lt += 1
          if(item.iscomplete == 'Upcoming') this.ot -= 1
          else if(item.iscomplete == 'Open') this.og -= 1
          item.state = 'warning'
          item.iscomplete += ' (Late)'
        }
        if(item.finishtime == '-' && this.$moment(this.$moment().format('YYYY-MM-DD')).isAfter(item.duedate)) {
          this.odt += 1
          if(item.iscomplete == 'Upcoming') this.ot -= 1
          else if(item.iscomplete == 'Open') this.og -= 1
          item.state = 'danger'
          item.iscomplete += ' (Overdue)'
        }
      }
      return item
    }
  },
  mounted() {
    this.role = this.$session.get('role')
    // console.log(this.role)
    this.$http.get(this.$url+'account/'+this.$session.get('token'))
    .then((result) => {
      this.workerlist = result.data
      // console.log(this.workerlist)
      this.workerlist.forEach(element => {
        this.workerwork.push({"name":element.name,"list":[]})
      });
      // console.log(this.workerwork)
      this.$http.get(this.$url+'getform/'+this.$session.get('token'))
      .then((result) => {
        this.formlist = result.data
        this.$http.get(this.$url+'getwork/'+this.$session.get('token'))
        .then((result) => {
          this.users = result.data
          this.tempdata = this.users
          this.users.forEach(element => {
            if(element.plandate) {
              this.attributes.push({
                highlight: 'red',
                dates: this.$moment(element.plandate)._d
              })
            }
            this.workerwork.forEach(el => {
              if(el.name == element.name) {
                el.list.push(element)
              }
            });
          })
          // console.log(this.workerwork)
          this.users = this.users.map(element => this.formating(element));
        })
      });
    })
  }
}
</script>
<style>
.vs-dialog {
  max-height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
}
input {
  border-radius: 0px;
}
button {
  border-radius: 0px;
}
.btn.btn-primary {
  border-radius: 0px;
}
.btn.btn-secondary {
  border-radius: 0px;
}
.btn.btn-warning {
  border-radius: 0px;
}
.btn.btn-danger {
  border-radius: 0px;
}
#center{
   display: flex;
  align-items: center;
}
.btn.btn-info {
  border-radius: 0px;
}
.list-group-item.list-group-item-action {
  border-radius: 0px;
}
.form-control {
  border-radius: 0px;
}
p.copyright-text{
  display:none;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap
}
.con-select .vs-select {
  width: 100%
}
.vuesax-app-is-ltr .vs-input--input.hasIcon {
    padding-left: 32px;
    border-radius: 20px;
}
.vs-select--item.con-icon.activex {
    padding-left: 30px;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%
  }
}
th {
  padding: 0px; 
}
.col-md-1.control-view-wrapper {
  padding-left: 1%;
}
.col-md-2.control-view-wrapper {
  padding-left: 1%;
}
.col-md-3.control-view-wrapper {
  padding-left: 1%;
}
.col-md-4.control-view-wrapper {
  padding-left: 1%;
}
.col-md-6.control-view-wrapper {
  padding-left: 1%;
}
.col-md-12.control-view-wrapper {
  padding-left: 1%;
}
.vs-divider-border.before.vs-divider-border-default {
  background-color: #6eda78;
}

</style>

<style scoped>
input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}
#btncancel{
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
.con-vs-card >>> .vs-card--header >>> .Test {
  padding-bottom: 0%;
}

.con-vs-card >>> .vs-card--header  {
  
  background: linear-gradient(45deg,#6eda78,#2ed8b6);
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
   
}
.con-vs-card.a >>> .vs-card--header  {
  
  background: linear-gradient(45deg,rgb(38,192,183),rgb(52,211,167));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
   
}
.con-vs-card.b >>> .vs-card--header  {
  background: linear-gradient(45deg,rgb(238,122,111),rgb(248,178,143));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
   
}
.con-vs-card.c >>> .vs-card--header  {
  background: linear-gradient(45deg,rgb(86,135,232),rgb(55,185,224));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
   
}
.con-vs-card.d >>> .vs-card--header  {
  background: linear-gradient(45deg,rgb(243,126,151),rgb(243,126,151));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
   
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap
}
.con-select .vs-select {
  width: 100%
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%
  }
  
  
}
.vschip {
  font-size: 100%;
 
}
th {
  padding: 0px;
}
.con-vs-dialog >>> .vs-dialog {
  width: 50%;
  max-width: 1000px;
}

  button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
    border-radius: 5px;
  }
 


</style>
<style >
 th .sort-th .th-sort-icon {
    color: white;
    padding: 0px;
}
</style>
